<!-- =========================================================
     CREATE RESTAURANT MODAL / COMPONENT
========================================================= -->

<app-create-app
  *ngIf="AppService.isApp"
  [domain]="domain"
  (reloadapps)="get()"
></app-create-app>

<!-- =========================================================
     GLOBAL LOADING STATES
========================================================= -->

<app-spinner
  *ngIf="load_delete"
  [loading]="load_delete"
  [fullScreen]="true"
  [text]="'Deleting in progress, please wait'"
></app-spinner>

<app-spinner
  *ngIf="load_check"
  [loading]="load_check"
  [fullScreen]="true"
  [text]="'ვამოწმებთ დომენს'"
></app-spinner>

<app-error
  *ngIf="error"
  [title]="''"
></app-error>

<!-- =========================================================
     WORKSPACES PAGE
========================================================= -->

<section class="ml-workspaces" *ngIf="!error">
  <!-- Background decoration -->
  <div class="ml-workspaces__background" aria-hidden="true">
    <div class="ml-workspaces__glow ml-workspaces__glow--one"></div>
    <div class="ml-workspaces__glow ml-workspaces__glow--two"></div>
    <div class="ml-workspaces__grid"></div>
  </div>

  <!-- =====================================================
       PAGE HEADER
  ====================================================== -->

  <header class="ml-workspaces__header">
    <div class="ml-workspaces__heading">
      <span class="ml-workspaces__eyebrow">
        RESTAURANT WORKSPACES
      </span>

      <h1>
        კეთილი იყოს შენი დაბრუნება
        <span>{{ admin.user?.name || '' }}</span>
      </h1>

      <p>
        შექმენი ახალი რესტორანი ან მართე უკვე არსებული
        Menuload სივრცეები ერთი ადგილიდან.
      </p>
    </div>

    <div class="ml-workspaces__header-status">
      <span class="ml-workspaces__status-icon">
        <i class="fi fi-rr-shield-check"></i>
      </span>

      <span>
        <small>Account status</small>
        <strong>Active and protected</strong>
      </span>

      <i class="ml-workspaces__status-dot"></i>
    </div>
  </header>

  <!-- =====================================================
       PAGE STATISTICS
  ====================================================== -->

  <div class="ml-workspaces__stats">
    <article class="ml-workspaces-stat">
      <span class="ml-workspaces-stat__icon">
        <i class="fi fi-rr-apps"></i>
      </span>

      <div>
        <small>Total restaurants</small>

        <strong>
          {{ data?.length || 0 }}
        </strong>

        <span>
          Menuload workspaces
        </span>
      </div>
    </article>

    <article class="ml-workspaces-stat">
      <span class="ml-workspaces-stat__icon">
        <i class="fi fi-rr-circle-check"></i>
      </span>

      <div>
        <small>Active restaurants</small>

        <strong>
          {{ data?.length || 0 }}
        </strong>

        <span class="is-success">
          Ready to receive orders
        </span>
      </div>
    </article>

    <article class="ml-workspaces-stat">
      <span class="ml-workspaces-stat__icon">
        <i class="fi fi-rr-headset"></i>
      </span>

      <div>
        <small>Menuload support</small>

        <strong class="ml-workspaces-stat__text-value">
          Available
        </strong>

        <span>
          დახმარება ნებისმიერ ეტაპზე
        </span>
      </div>
    </article>
  </div>

  <!-- =====================================================
       CREATE RESTAURANT CARD
  ====================================================== -->

  <section class="ml-create-workspace">
    <div class="ml-create-workspace__content">
      <span class="ml-create-workspace__icon">
        <i class="fi fi-rr-plus"></i>
      </span>

      <div>
        <span class="ml-create-workspace__eyebrow">
          CREATE A NEW RESTAURANT
        </span>

        <h2>შექმენი შენი ციფრული რესტორანი</h2>

        <p>
          აირჩიე უნიკალური მისამართი, შემდეგ დაამატე მენიუ,
          პროდუქტები, შეკვეთები და თანამშრომლები.
        </p>
      </div>
    </div>

    <div class="ml-create-workspace__form">
      <label for="workspace-domain">
        Restaurant address
      </label>

      <div
        class="ml-domain-field"
        [class.is-invalid]="
          domain && (!isDomainValid || isDomainTaken)
        "
        [class.is-valid]="
          domain && isDomainValid && !isDomainTaken
        "
      >
        <span class="ml-domain-field__icon">
          <i class="fi fi-rr-globe"></i>
        </span>

        <input
          type="text"
          id="workspace-domain"
          [(ngModel)]="domain"
          [ngModelOptions]="{ standalone: true }"
          placeholder="{{ 'DOMAIN_NAME' | translate }}"
          autocomplete="off"
          spellcheck="false"
          maxlength="63"
          (input)="onDomainInput($event)"
        >

        <span
          class="ml-domain-field__suffix"
          [class.is-active]="domain"
        >
          .menuload.com
        </span>

        <span
          *ngIf="domain && isDomainValid && !isDomainTaken"
          class="ml-domain-field__validation is-success"
          aria-label="Domain is available"
        >
          <i class="fi fi-rr-check"></i>
        </span>

        <span
          *ngIf="domain && (!isDomainValid || isDomainTaken)"
          class="ml-domain-field__validation is-error"
          aria-label="Domain is invalid"
        >
          <i class="fi fi-rr-cross-small"></i>
        </span>
      </div>

      <div class="ml-domain-field__feedback">
        <span
          *ngIf="!domain"
          class="ml-domain-field__help"
        >
          გამოიყენე ლათინური ასოები, ციფრები და დეფისი.
        </span>

        <span
          *ngIf="domain && !isDomainValid"
          class="ml-domain-field__error"
        >
          დაშვებულია მხოლოდ ლათინური ასოები, ციფრები და დეფისი.
        </span>

        <span
          *ngIf="domain && isDomainTaken"
          class="ml-domain-field__error"
        >
          ეს მისამართი უკვე დაკავებულია.
        </span>

        <span
          *ngIf="domain && isDomainValid && !isDomainTaken"
          class="ml-domain-field__success"
        >
          მისამართის ფორმატი სწორია.
        </span>
      </div>

      <button
        type="button"
        class="ml-create-workspace__button"
        [disabled]="
          !domain ||
          !isDomainValid ||
          isDomainTaken ||
          load_check
        "
        (click)="
          openPayModal({
            create: true,
            sub_domain: domain
          })
        "
      >
        <span *ngIf="!load_check">
          შექმენი რესტორანი
        </span>

        <span
          *ngIf="load_check"
          class="ml-create-workspace__button-loader"
        >
          <i></i>
          მოწმდება
        </span>

        <i
          *ngIf="!load_check"
          class="fi fi-rr-arrow-small-right"
        ></i>
      </button>
    </div>

    <div class="ml-create-workspace__steps">
      <div>
        <span>01</span>

        <strong>Choose address</strong>

        <small>შეარჩიე უნიკალური subdomain</small>
      </div>

      <div>
        <span>02</span>

        <strong>Add your menu</strong>

        <small>შექმენი კატეგორიები და პროდუქტები</small>
      </div>

      <div>
        <span>03</span>

        <strong>Start receiving orders</strong>

        <small>მიიღე შეკვეთები რეალურ დროში</small>
      </div>
    </div>
  </section>

  <!-- =====================================================
       RESTAURANT LIST HEADER
  ====================================================== -->

  <div class="ml-workspaces__list-header">
    <div>
      <span class="ml-workspaces__list-eyebrow">
        YOUR RESTAURANTS
      </span>

      <h2>შექმნილი რესტორნები</h2>

      <p>
        მართე თითოეული რესტორნის მენიუ, შეკვეთები,
        ანალიტიკა და პარამეტრები.
      </p>
    </div>

    <div
      *ngIf="!load && data?.length"
      class="ml-workspaces__list-count"
    >
      <span>{{ data.length }}</span>
      restaurant{{ data.length === 1 ? '' : 's' }}
    </div>
  </div>

  <!-- =====================================================
       LOADING STATE
  ====================================================== -->

  <div
    class="ml-workspaces__loading"
    *ngIf="load"
  >
    <app-spinner
      [loading]="load"
      [text]="'Restaurants are loading...'"
    ></app-spinner>
  </div>

  <!-- =====================================================
       EMPTY STATE
  ====================================================== -->

  <div
    class="ml-workspaces-empty"
    *ngIf="!load && (!data || data.length === 0)"
  >
    <span class="ml-workspaces-empty__icon">
      <i class="fi fi-rr-store-alt"></i>
    </span>

    <span class="ml-workspaces-empty__eyebrow">
      NO RESTAURANTS YET
    </span>

    <h3>შექმენი შენი პირველი რესტორანი</h3>

    <p>
      აირჩიე მისამართი ზემოთ მოცემულ ველში და დაიწყე
      Menuload-ის გამოყენება რამდენიმე წუთში.
    </p>

    <button
      type="button"
      [disabled]="!domain || !isDomainValid"
      (click)="
        openPayModal({
          create: true,
          sub_domain: domain
        })
      "
    >
      Create first restaurant
      <i class="fi fi-rr-arrow-small-right"></i>
    </button>
  </div>

  <!-- =====================================================
       RESTAURANT CARDS
  ====================================================== -->

  <div
    class="ml-workspaces__grid-list"
    *ngIf="!load && data?.length"
  >
    <article
      class="ml-restaurant-card"
      *ngFor="let item of data"
      [class.has-payment-warning]="
        item.payment_status === 'unpaid'
      "
    >
      <!-- Card gradient -->
      <div
        class="ml-restaurant-card__decoration"
        aria-hidden="true"
      ></div>

      <!-- Payment warning -->
      <div
        class="ml-restaurant-card__payment-warning"
        *ngIf="item.payment_status === 'unpaid'"
      >
        <span>
          <i class="fi fi-rr-exclamation"></i>
        </span>

        <div>
          <strong>Payment required</strong>

          <small>
            მომსახურების გასაგრძელებლად განაახლე პაკეტი.
          </small>
        </div>

        <button
          type="button"
          (click)="openPayModal(item)"
        >
          ვადის გაგრძელება
        </button>
      </div>

      <!-- Card header -->
      <header class="ml-restaurant-card__header">
        <div class="ml-restaurant-card__identity">
          <span class="ml-restaurant-card__logo">
            {{
              item?.sub_domain
                ? item.sub_domain.charAt(0).toUpperCase()
                : 'M'
            }}
          </span>

          <div>
            <span class="ml-restaurant-card__eyebrow">
              RESTAURANT WORKSPACE
            </span>

            <h3>
              {{ item.sub_domain }}
            </h3>

            <a
              href="https://{{ item.sub_domain }}.menuload.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ item.sub_domain }}.menuload.com

              <i class="fi fi-rr-arrow-up-right-from-square"></i>
            </a>
          </div>
        </div>

        <div class="ml-restaurant-card__header-actions">
          <button
            type="button"
            class="ml-restaurant-card__icon-button"
            aria-label="Open QR code"
            title="QR code"
            (click)="openQrModal(item)"
          >
            <i class="fi fi-rr-qrcode"></i>
          </button>

          <a
            href="https://{{ item.sub_domain }}.menuload.com"
            target="_blank"
            rel="noopener noreferrer"
            class="ml-restaurant-card__icon-button"
            aria-label="Open restaurant website"
            title="Open website"
          >
            <i class="fi fi-rr-arrow-up-right-from-square"></i>
          </a>
        </div>
      </header>

      <!-- Status row -->
      <div class="ml-restaurant-card__status-row">
        <div class="ml-restaurant-card__status">
          <span
            class="ml-restaurant-card__status-dot"
            [class.is-warning]="
              item.payment_status === 'unpaid'
            "
          ></span>

          <span>
            <small>Workspace status</small>

            <strong>
              {{
                item.payment_status === 'unpaid'
                  ? 'Payment required'
                  : 'Active'
              }}
            </strong>
          </span>
        </div>

        <div class="ml-restaurant-card__expiry">
          <span>
            <i class="fi fi-rr-calendar"></i>
          </span>

          <div>
            <small>Package expires</small>

            <strong>
              {{
                item.payment_expiry_date
                  | date: 'dd.MM.yyyy'
              }}
            </strong>
          </div>
        </div>
      </div>

      <!-- Quick management links -->
      <div class="ml-restaurant-card__management">
        <span class="ml-restaurant-card__section-label">
          QUICK MANAGEMENT
        </span>

        <div class="ml-restaurant-card__actions">
          <a
            [routerLink]="['/app/orders', item?.id]"
            class="ml-restaurant-action"
          >
            <span>
              <i class="fi fi-rr-order-history"></i>
            </span>

            <div>
              <strong>Orders</strong>
              <small>Manage live orders</small>
            </div>

            <i class="fi fi-rr-angle-small-right"></i>
          </a>

          <a
            [routerLink]="['/app/products', item?.id]"
            class="ml-restaurant-action"
          >
            <span>
              <i class="fi fi-rr-hamburger-soda"></i>
            </span>

            <div>
              <strong>Menu</strong>
              <small>Products and categories</small>
            </div>

            <i class="fi fi-rr-angle-small-right"></i>
          </a>

          <a
            [routerLink]="['/app/analitic', item?.id]"
            class="ml-restaurant-action"
          >
            <span>
              <i class="fi fi-rr-chart-histogram"></i>
            </span>

            <div>
              <strong>Analytics</strong>
              <small>Restaurant performance</small>
            </div>

            <i class="fi fi-rr-angle-small-right"></i>
          </a>

          <a
            [routerLink]="['/app/setting', item?.id]"
            class="ml-restaurant-action"
          >
            <span>
              <i class="fi fi-rr-settings"></i>
            </span>

            <div>
              <strong>Settings</strong>
              <small>Restaurant configuration</small>
            </div>

            <i class="fi fi-rr-angle-small-right"></i>
          </a>
        </div>
      </div>

      <!-- Card footer -->
      <footer class="ml-restaurant-card__footer">
        <button
          type="button"
          class="ml-restaurant-card__refresh"
          [disabled]="updateLoad"
          (click)="updateSite(item.sub_domain, item.id)"
        >
          <i
            class="fi fi-rr-refresh"
            [class.is-spinning]="updateLoad"
          ></i>

          <span>
            {{ updateLoad ? 'ახლდება...' : 'საიტის განახლება' }}
          </span>
        </button>

        <button
          type="button"
          class="ml-restaurant-card__primary"
          (click)="navigateToProducts(item.id)"
        >
          Manage restaurant
          <i class="fi fi-rr-arrow-small-right"></i>
        </button>
      </footer>
    </article>
  </div>

  <!-- =====================================================
       BOTTOM HELP STRIP
  ====================================================== -->

  <div class="ml-workspaces__help">
    <div class="ml-workspaces__help-content">
      <span class="ml-workspaces__help-icon">
        <i class="fi fi-rr-headset"></i>
      </span>

      <div>
        <strong>გჭირდება დახმარება რესტორნის შექმნაში?</strong>

        <small>
          Menuload-ის გუნდი დაგეხმარება მენიუს, შეკვეთებისა
          და სამუშაო სივრცის გამართვაში.
        </small>
      </div>
    </div>

    <a href="mailto:info@menuload.com">
      Contact support
      <i class="fi fi-rr-arrow-small-right"></i>
    </a>
  </div>
</section>